import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { openCookieSettings } from "@/consent";

const LINKS = [
  { to: "/shiatsu", label: "Shiatsu", id: "shiatsu" },
  { to: "/begleitung", label: "1:1 Begleitung", id: "begleitung" },
  { to: "/yoga", label: "Yoga", id: "yoga" },
  { to: "/aktuelles", label: "Aktuelles", id: "aktuelles" },
  { to: "/ueber-mich", label: "Über mich", id: "ueber-mich" },
  { to: "/kundenstimmen", label: "Kundenstimmen", id: "kundenstimmen" },
  { to: "/kontakt", label: "Kontakt", id: "kontakt" },
];

export default function Footer() {
  return (
    <footer>
      <section
        data-testid="hinweis-section"
        aria-label="Hinweis"
        className="border-t border-anthrazit/10 bg-taupe/25"
      >
        <div className="mx-auto max-w-3xl px-6 py-14 text-center md:py-16">
          <p className="mb-5 text-xs uppercase tracking-[0.35em] text-rot">Hinweis</p>
          <p className="text-sm leading-loose text-anthrazit/75">
            Meine Begleitung ersetzt keine Psychotherapie oder medizinische Behandlung. Sie richtet
            sich an Menschen, die ihre Gesundheit aktiv unterstützen, ihre eigenen Ressourcen
            stärken und die Verbindung zu sich selbst vertiefen möchten.
          </p>
        </div>
      </section>

      <div className="bg-tanne text-creme">
        <div className="mx-auto flex max-w-7xl flex-col gap-10 px-6 py-14 md:flex-row md:items-end md:justify-between md:px-12 md:py-16">
          <div>
            <Link
              to="/"
              data-testid="footer-brand-link"
              className="font-script text-5xl leading-none tracking-wide"
            >
              Dein Körper spricht mit dir
            </Link>
          </div>
          <div className="flex flex-col gap-6">
            <nav className="flex flex-wrap gap-x-7 gap-y-3" aria-label="Fußzeilen-Navigation">
              {LINKS.map((l) => (
                <Link
                  key={l.id}
                  to={l.to}
                  data-testid={`footer-link-${l.id}`}
                  className="text-sm tracking-[0.1em] text-creme/75 transition-colors duration-300 hover:text-creme"
                >
                  {l.label}
                </Link>
              ))}
            </nav>
            <a
              href="https://instagram.com/seelenpfad_carmen_hackradt"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-instagram-link"
              aria-label="Dein Körper spricht mit dir auf Instagram"
              className="inline-flex w-fit items-center gap-3 text-sm tracking-[0.1em] text-creme/75 transition-colors duration-300 hover:text-creme"
            >
              <Instagram size={17} strokeWidth={1.5} />
              Instagram
            </a>
          </div>
        </div>
        <div className="border-t border-creme/15">
          <div className="mx-auto flex max-w-7xl flex-col gap-4 px-6 py-6 md:flex-row md:items-center md:justify-between md:px-12">
            <p className="text-xs tracking-[0.15em] text-creme/50">
              © {new Date().getFullYear()} Dein Körper spricht mit dir
            </p>
            <nav className="flex flex-wrap gap-x-6 gap-y-2" aria-label="Rechtliches">
              <Link
                to="/impressum"
                data-testid="footer-link-impressum"
                className="text-xs tracking-[0.15em] text-creme/60 transition-colors duration-300 hover:text-creme"
              >
                Impressum
              </Link>
              <Link
                to="/datenschutz"
                data-testid="footer-link-datenschutz"
                className="text-xs tracking-[0.15em] text-creme/60 transition-colors duration-300 hover:text-creme"
              >
                Datenschutz
              </Link>
              <Link
                to="/cookies"
                data-testid="footer-link-cookies"
                className="text-xs tracking-[0.15em] text-creme/60 transition-colors duration-300 hover:text-creme"
              >
                Cookies
              </Link>
              <button
                type="button"
                data-testid="footer-cookie-settings-button"
                onClick={openCookieSettings}
                className="text-xs tracking-[0.15em] text-creme/60 transition-colors duration-300 hover:text-creme"
              >
                Cookie-Einstellungen
              </button>
            </nav>
          </div>
        </div>
      </div>
    </footer>
  );
}
